export const maxLengthValidator = (maxLength) => (value) => {
    if (!value||!maxLength) return ""
    return value.slice(0, maxLength)
}